import { render } from "./Logs.pug?vue&type=template&id=189a0969&ts=true&lang=pug&external"
import script from "./Logs.ts?vue&type=script&lang=ts&external"
export * from "./Logs.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Logs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "189a0969"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('189a0969', __exports__)) {
    api.reload('189a0969', __exports__)
  }
  
  module.hot.accept("./Logs.pug?vue&type=template&id=189a0969&ts=true&lang=pug&external", () => {
    api.rerender('189a0969', render)
  })

}


export default __exports__